import { useDevelopersModuleQuery } from '../../../../../../schema'
import { createStrictContext } from '../../../../../../utils/createContext'
import { DefaultQueryHookOptions } from '../../../../../../utils/defaults'
import { DevelopersModuleContext } from './types'

const { Provider, useContextFn } = createStrictContext<DevelopersModuleContext>(
  'DeveloperModuleContext'
)

export const useDevelopersModuleContext = useContextFn

const DevelopersModuleProvider: React.FC = ({ children }) => {
  const { data, loading, refetch } = useDevelopersModuleQuery(
    DefaultQueryHookOptions
  )

  return (
    <Provider
      value={{
        users: data?.users.records ?? [],
        developers:
          data?.users.records.filter(({ developer }) => developer) ?? [],
        loading,
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}

export default DevelopersModuleProvider
